import { useState } from 'react'
import React from "react";
import { ElementProps, ImageElementProps } from '@/types/elements';
import cn from "clsx";

import { ArrowUpRight } from 'react-feather';
import BlurImage from '../BlurImage';
import clsx from 'clsx';

import ScrollReveal from "@/components/ScrollReveal";

export default function ImageElement({ block: { data, columns, id: blockId }, viewMode, tracer, appearance }: ElementProps) {
    columns = columns || (data.length > 1 ? 2 : 1);
    return (
        <div className={`grid gap-4 grid-cols-${columns}`}>
            {data.map((image: ImageElementProps, index: number) => {
                return (
                    <figure className="relative" key={index}
                        onClick={() => {
                            if (image.link && image.link.length > 0) {
                                window.open(image.link, '_blank');
                            }
                        }}>
                        {/* <img className={cn(
                            "rounded-lg w-full aspect-square cursor-pointer	object-cover shadow-xl hover:shadow-2xl",
                            columns! > 1 ? `h-40 ${viewMode ? 'md:h-72' : ''}` : 'image-item',
                        )}
                            style={{ maxHeight: '100vh' }}
                            src={image.url} alt={image.caption} /> */}
                        <div className={clsx("flex-none overflow-hidden rounded-lg cursor-pointer group", appearance?.corner === 'square' ? 'rounded-none' : 'rounded-lg')}>
                            <BlurImage
                                className="object-cover w-full h-full aspect-auto hover:brightness-90 hover:scale-110"
                                alt={image.caption}
                                width={400}
                                height={400}
                                layout="responsive"
                                objectFit="cover"
                                src={image.url}
                                blurDataURL={image.blurHash}
                            />
                        </div>
                        {image.link && image.link.length > 0 && <div
                            className="absolute right-0 flex w-8 m-auto shadow-2xl top-2 md:w-10">
                            <ArrowUpRight className="stroke-white" height={24} width={24} />
                        </div>}
                        {image.caption.length > 0 && <figcaption className="absolute bottom-0 w-full px-2 py-2.5 text-xs text-white md:text-md">
                            <span className="p-1 bg-black text-caption bg-opacity-30">{image.caption}</span>
                        </figcaption>}
                    </figure>
                )
            })}
        </div>
    )
}
